<div class="card">
  <div class="card-header">
    {{ 'REGISTER.PROFILE' | translate }}
  </div>
  <div class="card-block">
    <form #registerProfileForm="ngForm">
      <div class="card-block">
        <section class="form-block">
          <div class="form-group" id="outter-div">
            <label class="required" id="label">{{ 'SHARED.FIRST_NAME' | translate }}:</label>
            <label for="firstname" aria-haspopup="true" role="tooltip" class="tooltip tooltip-bottom-left tooltip-validation tooltip-sm" [ngClass]="{'invalid': firstname.dirty && firstname.invalid}">
              <input type="text" name="firstname" class="inner-input" id="firstname" placeholder="{{ 'SHARED.FIRST_NAME' | translate }}" [(ngModel)]="model.firstname" #firstname="ngModel" required />
              <span class="tooltip-content">
                {{ 'SHARED.FIRST_NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}
              </span>
            </label>
          </div>
          <div class="form-group" id="outter-div">
            <label class="required" id="label">{{ 'SHARED.LAST_NAME' | translate }}:</label>
            <label for="lastname" aria-haspopup="true" role="tooltip" class="tooltip tooltip-bottom-left tooltip-validation tooltip-sm" [ngClass]="{'invalid': lastname.dirty && lastname.invalid}">
              <input type="text" name="lastname" class="inner-input" id="lastname" placeholder="{{ 'SHARED.LAST_NAME' | translate }}" [(ngModel)]="model.lastname" #lastname="ngModel" required />
              <span class="tooltip-content">
                {{ 'SHARED.LAST_NAME' | translate }} {{ 'SHARED.IS_REQUIRED' | translate }}
              </span>
            </label>
          </div>
          <div class="form-group" id="outter-div">
            <label id="label">{{ 'SHARED.TEL_NUMBER' | translate }}:</label>
            <label for="lastname" aria-haspopup="true" role="tooltip" class="tooltip tooltip-bottom-left tooltip-validation tooltip-sm">
              <input type="tel" name="telNumber" class="inner-input" id="telNumber" placeholder="{{ 'SHARED.TEL_NUMBER' | translate }}" [(ngModel)]="model.telNumber" #lastname="ngModel" />
            </label>
          </div>
          <div class="form-group" id="outter-div">
            <label class="required" id="label">{{ 'USER.PREFERRED_LANGUAGE' | translate }}:</label>
            <label for="preferredLanguage" aria-haspopup="true" role="tooltip" class="tooltip tooltip-bottom-left tooltip-validation tooltip-sm">
              <div class="select">
                <select class="inner-input" id="preferredLanguage" [(ngModel)]="model.languageId" name="language">
                  <option *ngFor="let language of languages" [ngValue]="language.languageId">
                    {{ language.name }}
                  </option>
                </select>
              </div>
            </label>
          </div>
        </section>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <button type="button" class="btn btn-primary" (click)="registerProfile()" [disabled]="!registerProfileForm.form.valid">{{ 'SHARED.NEXT' | translate }}</button>
  </div>
</div>
